import { DRMLicenseKey } from 'enums/drm';
import PlatformHelper from 'helpers/PlatformHelper';
import VideoDetails from 'models/VideoDetails';

const shaka = require('external/shaka-player.ui.debug');

export function loadDash(videoDetails: VideoDetails, player: any): Promise<unknown> {
  const licenseType = PlatformHelper.drmLicenseType;

  player.configure({
    drm: {
      servers: {
        [DRMLicenseKey[licenseType]]: PlatformHelper.drmLicenseServerUrl,
      },
    },
  });

  player.getNetworkingEngine().registerRequestFilter(function (type, request) {
    // Only add headers to license requests:
    if (type == shaka.net.NetworkingEngine.RequestType.LICENSE) {
      // This is the specific header name and value the server wants:
      request.headers['customdata'] = videoDetails.customData;
    }
  });

  return player.load(videoDetails.dash);
}
